import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoLuminariasComponent } from './luminarias/listado-luminarias/listado-luminarias.component';
import { CrearEditarLuminariaComponent } from './luminarias/crear-editar-luminaria/crear-editar-luminaria.component';
import { ListadoGruposComponent } from '../../standalone/grupos/listado-grupos/listado-grupos.component';
import { AsignadorEntidadesGrupoComponent } from '../../standalone/grupos/asignador/asignador-entidades-grupo.component';
import { ListadoUbicacionesComponent } from '../../standalone/ubicaciones/listado-ubicaciones/listado-ubicaciones.component';
import { CrearEditarUbicacionComponent } from '../../standalone/ubicaciones/crear-editar-ubicacion/crear-editar-ubicacion.component';
import { ListadoPuestasComponent } from '../../standalone/puestas/listado-puestas/listado-puestas.component';
import { MapaLuminariasComponent } from './mapa-luminarias/mapa-luminarias.component';
import { DetallesLuminariaComponent } from './luminarias/detalles-luminaria/detalles-luminaria.component';
import { DashboardLuminariasComponent } from './dashboard-luminarias/dashboard-luminarias.component';
import { DashboardEntidadLuminariasComponent } from '../../standalone/dashboard-entidad-luminarias/dashboard-entidad-luminarias.component';
import { SeguimientoLuminariasComponent } from './seguimiento/seguimiento.component';
import { DetalleAplicacionComponent } from './seguimiento/perfiles/detalle-aplicacion.component';
import { DetalleEncendidoComponent } from './seguimiento/encendidos/detalle-encendido.component';

const routes: Routes = [
  { path: '', redirectTo: 'mapa', pathMatch: 'full' },

  //Mapa
  {
    path: 'luminarias',
    title: 'Luminarias',
    component: ListadoLuminariasComponent,
    canActivate: [],
  },
  // Activos
  {
    path: 'luminarias/crear',
    title: 'Nueva luminaria',
    component: CrearEditarLuminariaComponent,
    canActivate: [],
  },
  {
    path: 'luminarias/editar/:id',
    title: 'Editar luminaria',
    component: CrearEditarLuminariaComponent,
    canActivate: [],
  },
  {
    path: 'luminarias/detalles/:id',
    title: 'Luminaria',
    component: DetallesLuminariaComponent,
    canActivate: [],
  },

  //Mapa
  {
    path: 'mapa',
    title: 'Mapa de luminarias',
    component: MapaLuminariasComponent,
    canActivate: [],
  },

  // Agrupaciones ( categoria: 'Luminaria') y grupos de puestas (categoria 'Puesta')
  {
    path: 'grupos/:categoria',
    title: 'Grupos',
    component: ListadoGruposComponent,
    canActivate: [],
  },
  // Asignar entidades (luminarias/puestas) a un grupo desde el grupo.
  {
    path: 'grupos/:categoria/asignar/:id',
    title: 'Asignar a grupo',
    component: AsignadorEntidadesGrupoComponent,
    canActivate: [],
  },

  // Zonas de alumbrado (IUbicacion categoria 'Luminarias')
  {
    path: 'zonas/:categoria',
    title: 'Zonas',
    component: ListadoUbicacionesComponent,
    canActivate: [],
  },
  {
    path: 'zonas/:categoria/crear',
    title: 'Nueva zona',
    component: CrearEditarUbicacionComponent,
    canActivate: [],
  },
  {
    path: 'zonas/:categoria/editar/:id',
    title: 'Editar zona',
    component: CrearEditarUbicacionComponent,
    canActivate: [],
  },

  // Puestas (clientes con moduloLuminarias.usaPuestas)
  {
    path: 'puestas',
    title: 'Puestas',
    component: ListadoPuestasComponent,
    canActivate: [],
  },

  // Dashboard
  {
    path: 'dashboard',
    title: 'Dashboard de luminarias',
    component: DashboardLuminariasComponent,
    canActivate: [],
  },

  // Dashboard de detalle de una entidad agregada
  // (nivel: grupoLuminaria | puesta | grupoPuesta)
  {
    path: 'detalle-entidad/:nivel/:id',
    title: 'Resumen de luminarias',
    component: DashboardEntidadLuminariasComponent,
    canActivate: [],
  },

  // Seguimiento: cómo vienen los perfiles y los encendidos/apagados mandados.
  // La solapa va en la ruta para que el "volver" de cada detalle caiga en ella.
  {
    path: 'seguimiento',
    redirectTo: 'seguimiento/perfiles',
    pathMatch: 'full',
  },
  {
    path: 'seguimiento/perfiles',
    title: 'Seguimiento de perfiles',
    component: SeguimientoLuminariasComponent,
    data: { vista: 'perfiles' },
    canActivate: [],
  },
  {
    path: 'seguimiento/perfiles/:id',
    title: 'Envío de perfil',
    component: DetalleAplicacionComponent,
    canActivate: [],
  },
  {
    path: 'seguimiento/encendidos',
    title: 'Seguimiento de encendidos',
    component: SeguimientoLuminariasComponent,
    data: { vista: 'encendidos' },
    canActivate: [],
  },
  {
    path: 'seguimiento/encendidos/:id',
    title: 'Envío de encendido',
    component: DetalleEncendidoComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LuminariasRoutingModule {}
